import React from "react";
import './ProductContent.scss';
import { Demo, ExamResult, ReadingBook } from "../../../../../../../assets/svg";


const content = [
    {
        id: 1,
        content: "Learn",
        name: <ReadingBook />
    },
    {
        id: 2,
        content: "Documents",
        name: <ExamResult />
    },
    {
        id: 3,
        content: "Use Demo Case",
        name: <Demo />
    },
    // {
    //     id: 4,
    //     content: "Installation Guides",
    //     name: '4'
    // }
]

function ProductContent() {
    return (
        <div className="product-content">
            <div className="title">How It Works</div>
            <div className="middle">
                {
                    content.map((item, index) => (
                        <div className="wrapper" key={index}>
                            <div className="icon-wrapper">{item.name}</div>
                            <p className="product-title">{item.content}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ProductContent;